function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "50",
  height: "65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.545 38.365L13.988 35 7 61.08l.144.039 7.483-3.39 4.786 6.677.144.039 6.988-26.08z",
  fill: "#36448C"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.83 35.222l-12.557 3.365 6.989 26.08.141-.038 4.787-6.677 7.483 3.39.146-.04-6.989-26.08z",
  fill: "#36448C"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.206 3.039a1 1 0 011.588 0l2.345 3.065a1 1 0 001.273.27L32.8 4.529a1 1 0 011.451.646l.895 3.754a1 1 0 001.053.765l3.847-.31a1 1 0 011.063 1.181l-.71 3.794a1 1 0 00.651 1.127l3.64 1.282a1 1 0 01.49 1.511l-2.19 3.177a1 1 0 00.136 1.294l2.804 2.652a1 1 0 01-.166 1.58l-3.294 2.011a1 1 0 00-.402 1.238l1.482 3.563a1 1 0 01-.794 1.376l-3.827.497a1 1 0 00-.87.967l-.096 3.858a1 1 0 01-1.285.934l-3.698-1.102a1 1 0 00-1.19.53l-1.655 3.485a1 1 0 01-1.554.33l-2.93-2.51a1 1 0 00-1.302 0l-2.93 2.51a1 1 0 01-1.554-.33l-1.656-3.486a1 1 0 00-1.189-.529l-3.698 1.102a1 1 0 01-1.285-.934l-.095-3.858a1 1 0 00-.871-.967l-3.827-.497a1 1 0 01-.794-1.376l1.482-3.563a1 1 0 00-.402-1.238l-3.294-2.011a1 1 0 01-.166-1.58l2.804-2.652a1 1 0 00.136-1.294l-2.19-3.177a1 1 0 01.49-1.51l3.64-1.283a1 1 0 00.65-1.127l-.709-3.794a1 1 0 011.063-1.18l3.847.309a1 1 0 001.053-.765l.895-3.754a1 1 0 011.45-.646l3.39 1.847a1 1 0 001.272-.271l2.345-3.065z",
  fill: "#FFE96C"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: ".758",
  y: ".646",
  width: "48.485",
  height: "48.263",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "1.5"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));